import React from "react";




interface TrustedPartnersHeaderProps {
  // Future props can be added here
}




const TrustedPartnersHeader: React.FC<TrustedPartnersHeaderProps> = () => {
  const handleScrollToPartners = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const partnersSection = document.querySelector("#partners");
    if (partnersSection) {
      partnersSection.scrollIntoView({ behavior: "smooth" });
    }
  };




  return (
    <div className="bg-primary text-white flex flex-col md:flex-row relative md:h-[360px]">
      <ContentSection onScrollToPartners={handleScrollToPartners} />
      <ImageSection />
    </div>
  );
};




const ContentSection: React.FC<{ onScrollToPartners: (e: React.MouseEvent<HTMLAnchorElement>) => void }> = ({
  onScrollToPartners
}) => (
  <div className="md:w-1/2 p-8 flex flex-col items-center justify-center">
    <h1 className="text-5xl md:text-7xl font-medium font-sans tracking-wider text-center mb-4">
      Trusted Partners
    </h1>
    <h2 className="text-2xl md:text-3xl font-medium font-sans tracking-wider text-center mb-4">
      Empowering Your Financial Future
    </h2>
    <p className="text-base md:text-lg text-center mb-6 max-w-md">
      ClientVitals collaborates with leading financial institutions and technology providers to
      deliver secure, personalized credit and financial solutions for our clients.
    </p>
    <a
      href="#partners"
      className="inline-block bg-white text-primary font-medium py-2 px-4 rounded hover:bg-opacity-90 transition-colors"
      onClick={onScrollToPartners}
    >
      Explore Our Partners
    </a>
  </div>
);




const ImageSection: React.FC = () => (
  <div className="md:w-1/2 md:absolute md:right-0 md:top-0 md:bottom-0">
    <img
      src="/images/trusted-partners-header-temp.png"
      alt="Business partners in discussion"
      className="w-full h-full object-cover"
    />
  </div>
);




export default TrustedPartnersHeader;





















